// extracted by mini-css-extract-plugin
module.exports = {"switchInput":"Switch_switchInput__ho_h1","checked":"Switch_checked__6RKUz","disabled":"Switch_disabled__OrfhO"};